import React from "react";
import { ArrowLeft, ShoppingBag } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CartContent() {
  return <section data-section-id="17835" id="cart-content" className="bg-background py-16 md:py-24 min-h-[60vh]">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        {}
        <div className="mb-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="bg-secondary/20 p-3 rounded-full backdrop-blur-sm">
              <ShoppingBag className="h-6 w-6 text-primary" />
            </div>
            <h1 className="text-3xl md:text-5xl font-serif text-foreground tracking-tight">
              Your Selections
            </h1>
          </div>
          
          <Button asChild variant="ghost" className="w-fit text-muted-foreground hover:text-primary hover:bg-secondary/10 transition-colors">
            <Link to="/ShopPage">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Return to the Docks
            </Link>
          </Button>
        </div>

        {}
        <div className="bg-white/40 backdrop-blur-xl rounded-xl border border-white/20 shadow-md p-6 md:p-10 lg:p-12">
          <div className="w-full">
            {}
            <div className="woocommerce-cart-wrapper min-h-[200px]">
              [woocommerce_cart]
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 text-center border-t border-border pt-8">
          <div className="flex flex-col items-center gap-2">
            <span className="text-primary font-serif font-medium text-sm uppercase tracking-widest">Village Delivery</span>
            <p className="text-muted-foreground text-sm font-sans">Direct to your Florida doorstep</p>
          </div>
          <div className="flex flex-col items-center gap-2">
            <span className="text-primary font-serif font-medium text-sm uppercase tracking-widest">Pristine Quality</span>
            <p className="text-muted-foreground text-sm font-sans">Flash-frozen for peak freshness</p>
          </div>
          <div className="flex flex-col items-center gap-2">
            <span className="text-primary font-serif font-medium text-sm uppercase tracking-widest">Local Support</span>
            <p className="text-muted-foreground text-sm font-sans">Questions? Call (352) SEAFOOD</p>
          </div>
        </div>
      </div>
    </section>;
}